/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateDataSourceRequest } from '../../models/create-data-source-request';
import { DataSourceDto } from '../../models/data-source-dto';

export interface DatasourcesPost$Plain$Params {
      body?: CreateDataSourceRequest
}

export function datasourcesPost$Plain(http: HttpClient, rootUrl: string, params?: DatasourcesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DataSourceDto>> {
  const rb = new RequestBuilder(rootUrl, datasourcesPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataSourceDto>;
    })
  );
}

datasourcesPost$Plain.PATH = '/datasources';
